import type { Schemas, WorkflowConfigInput } from '@automata/wfb-api';

import { ok } from './utils';
import type { TimeConstraintInstancesById } from '../graph/graphSlice';

/**
 * Build workflow.planning_targets.timing_targets from timing targets attached to time-constraint connections.
 * Only uses anchors as the time-constraint endpoints (start/end of tasks).
 */
export const getJsonPlanningTargetsTimingTargets = (
  timeConstraintInstances: TimeConstraintInstancesById
): {
  timing_targets: NonNullable<
    WorkflowConfigInput['workflow']['planning_targets']
  >['timing_targets'];
  consistency?: Schemas.TaskEdgeSpanInput[];
} => {
  const timing_targets: Schemas.TimingTargetInput[] = [];
  const consistency: Schemas.TaskEdgeSpanInput[] = [];

  for (const tc of Object.values(timeConstraintInstances)) {
    if (tc.timingTargets && tc.timingTargets.length > 0) {
      for (const t of tc.timingTargets) {
        timing_targets.push({
          anchor_a: { task_id: tc.source, edge: tc.sourceType as any },
          anchor_b: { task_id: tc.target, edge: tc.targetType as any },
          target: t.target,
          weight: t.weight ?? 1,
        });
      }
    }

    if (tc.consistencyTargets && tc.consistencyTargets.length > 0) {
      for (const _ of tc.consistencyTargets) {
        consistency.push({
          anchor_a: { task_id: tc.source, edge: tc.sourceType as any },
          anchor_b: { task_id: tc.target, edge: tc.targetType as any },
        });
      }
    }
  }

  return {
    timing_targets,
    consistency: consistency.length > 0 ? consistency : undefined,
  };
};

export const getJsonPlanningTargetsStrict = (
  timeConstraintInstances: TimeConstraintInstancesById
) => {
  const data = getJsonPlanningTargetsTimingTargets(timeConstraintInstances);
  return ok(data);
};
